(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory('clipboardService', Handler)

	function Handler () {

		var clipboardService = {};

    clipboardService.init = function () {
			$('[data-toggle="tooltip"]').tooltip();

			function setTooltip(btn, message) {
			  $(btn)
			    .attr('data-original-title', message)
			    .tooltip('show');
			}

			function hideTooltip(btn, ms) {
			  setTimeout(function() {
			    $(btn).tooltip('hide');
			  }, ms);
			}

			// Initialize clipboard
			var clipboard = new Clipboard('.enable-copy');

			clipboard.on('success', function(e) {
			  setTooltip(e.trigger, 'Copied!');
			  hideTooltip(e.trigger, 1000);
			});

			clipboard.on('error', function(e) {
			  setTooltip(e.trigger, 'Press ⌘/CTRL + C to copy');
			  hideTooltip(e.trigger, 4000);
			});

    }

		return clipboardService;
	}

}());
